<template>
  <div>
    <headNav></headNav>
    <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/xmzs.jpg" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
          <div style="width: 100%;" class="btn-group-vertical " role="group">
           <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
           <router-link to="/gsjj"><button type="button" class="btn btn-default btn-block">公司简介</button></router-link>
           <router-link to="/wdjf"><button type="button" class="btn btn-default btn-block">威盾技防</button></router-link>
           <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
           <button type="button" class="btn btn-primary btn-block">项目展示</button>
           <router-link to="/wdtb"><button type="button" class="btn btn-default btn-block">威盾特保</button></router-link>
           <router-link to="/xwdt"><button type="button" class="btn btn-default btn-block">新闻动态</button></router-link>
           <router-link to="/bzzl"><button type="button" class="btn btn-default btn-block">报纸专栏</button></router-link>
           <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
          </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 text-left probject" >
            <div class="row">
              <div class="col-md-6">
                <div class=" mainBusinessScopexmzs">
                    <img src="../assets/probject_hndx.jpg" class="img-responsive">
                    <div style="padding: 10px;">
                      <h4>威盾保安在河南大学</h4>
                    </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class=" mainBusinessScopexmzs">
                    <img src="../assets/probject_zsy.jpg" class="img-responsive">
                    <div style="padding: 10px;">
                      <h4>威盾保安在中石油</h4>
                    </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 20px;">
              <div class="col-md-6">
                <div class=" mainBusinessScopexmzs">
                    <img src="../assets/probject_bmy.jpg" class="img-responsive">
                    <div style="padding: 10px;">
                      <h4>威盾保安在秦始皇兵马俑</h4>
                    </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class=" mainBusinessScopexmzs">
                    <img src="../assets/probject_ptz.jpg" class="img-responsive">
                    <div style="padding: 10px;">
                      <h4>威盾保安在莆田站</h4>
                    </div>
                </div>
              </div>
            </div>


        </div>
      </div>
    </div>
     <Base></Base>
  </div>

</template>

<script>
  $(function() {

  });

  export default {
    data() {
      return {

      }
    },
    methods: {}




  }
</script>

<style>
  .probject{
    margin-top: 30px;
  }
  .probject h4{
    font-size: 16px;
  }
  .mainBusinessScopexmzs{
    background-color: #FFFFFF;
    border: 1px solid #e6e9eb;
    border-radius:3px;
  }
  .mainBusinessScopexmzs p{
    font-size: 16px;
  }
  .fwfw .col-md-4{
    padding-left: 5px;
    padding-right: 5px;
  }
  .fwfw{
    margin-top: 10px;
  }
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
.row{
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xmzs.vue